import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CookieConsent from 'react-cookie-consent';
import Cookies from 'js-cookie';

// Komponenty główne
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Trust from './components/Trust';
import Stats from './components/Stats';
import Newsletter from './components/Newsletter';
import ContactForm from './components/ContactForm';
import Kontakt from './components/Kontakt';
import Footer from './components/Footer';
import ObslugaPrawnaBiznesu from './components/ObslugaPrawnaBiznesu';
import DoradztwoStrategiczne from './components/DoradztwoStrategiczne';
import ThankYouPage from './components/ThankYouPage';
import NoweTechnologie from './components/NoweTechnologie'; 
import PodatkiFinansowanie from './components/PodatkiFinansowanie';
import PomocPubliczna from './components/PomocPubliczna.js';
import PrawoSpolek from './components/PrawoSpolek';
import RozwiazywanieSporow from './components/RozwiazywanieSporow';
import WlasnoscIntelektualna from './components/WlasnoscIntelektualna';
import SubscriptionThankYou from './components/SubscriptionThankYou';
import PolitykaPrywatnosci from './components/PolitykaPrywatnosci';


// Podstrony Consulting
import WyszukiwarkaDofinansowan from './components/consulting/WyszukiwarkaDofinansowan';
import PozyskiwanieDofinansowan from './components/consulting/PozyskiwanieDofinansowan';
import RozliczanieDofinansowan from './components/consulting/RozliczanieDofinansowan';
import PozyckiUnijne from './components/consulting/PozyckiUnijne';
import BiznnesPlany from './components/consulting/BiznnesPlany';
import AboutUs from './components/AboutUs';

// Podstrony Dotacje
import SciezkaSmart from './components/dotacje/SciezkaSmart';

// --- LOGIKA COOKIE CONSENT ---
// Funkcja pomocnicza do ustawiania zgody - zdefiniowana na zewnątrz komponentu
const setGoogleConsent = (consent) => {
  if (window.gtag) {
    window.gtag('consent', 'default', consent);
  } else if (window.dataLayer) {
    window.dataLayer.push({ 'gtag.consent': 'default', ...consent });
  }
};
// -----------------------------


// Komponent strony głównej
const HomePage = ({ heroRef, isLoaded, mousePosition, activeService, setActiveService }) => {
  return (
    <>
      <Hero 
        heroRef={heroRef}
        isLoaded={isLoaded}
        mousePosition={mousePosition}
      />
      <Trust />
      <Stats />
      <Newsletter />
      <ContactForm />
    </>
  );
};

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [activeService, setActiveService] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const heroRef = useRef(null);

  // --- LOGIKA COOKIE CONSENT (USE EFFECT) ---
  useEffect(() => {
    // Ustawienie domyślnej zgody (zawsze "denied" przed interakcją użytkownika)
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;

    setGoogleConsent({
      'analytics_storage': 'denied',
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
    });
  }, []);
  // ------------------------------------------

  useEffect(() => {
    setIsLoaded(true);

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  // --- LOGIKA COOKIE CONSENT (HANDLERY) ---
  const handleAcceptCookie = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
      });
    }
  };

  const handleDeclineCookie = () => {
    // Ustawiamy cookie, aby baner nie pojawiał się ponownie.
    // Gtag pozostanie w stanie 'denied', ponieważ nie wywołujemy 'update'.
    Cookies.set("szynkowskiCookieConsent", "false", { expires: 150 });
  };
  // ----------------------------------------

  return (
    <Router>
      <div className="min-h-screen bg-black text-white overflow-x-hidden">
        {/* Usunąłem style globalne z tego miejsca, zakładając, że są w App.css */}
        <div className="noise"></div>

        <Navbar 
          scrolled={scrolled}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
        />

        <Routes>
          {/* Strona główna */}
          <Route path="/" element={
            <HomePage 
              heroRef={heroRef}
              isLoaded={isLoaded}
              mousePosition={mousePosition}
              activeService={activeService}
              setActiveService={setActiveService}
            />
          } />
          
          {/* Podstrony Consulting */}
          <Route path="/wyszukiwarka-dofinansowan" element={<WyszukiwarkaDofinansowan />} />
          <Route path="/pozyskiwanie-dofinansowan" element={<PozyskiwanieDofinansowan />} />
          <Route path="/rozliczanie-dofinansowan" element={<RozliczanieDofinansowan />} /> 
          <Route path="/pozyczki-unijne" element={<PozyckiUnijne />} /> 
          <Route path="/biznes-plany" element={<BiznnesPlany />} /> 

          {/* Podstrony Dotacje */}
          <Route path="/dotacje/sciezka-smart" element={<SciezkaSmart />} />
          
          {/* Podstrony Legal*/}
          <Route path="/nowe-technologie" element={<NoweTechnologie />} />
          <Route path="/podatki-finansowanie" element={<PodatkiFinansowanie />} />
          <Route path="/pomoc-publiczna" element={<PomocPubliczna />} />
          <Route path="/prawo-spolek" element={<PrawoSpolek />} /> 
          <Route path="/rozwiazywanie-sporow" element={<RozwiazywanieSporow />} />
          <Route path="/wlasnosc-intelektualna" element={<WlasnoscIntelektualna />} />

          <Route path="/o-nas" element={<AboutUs />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/obsluga-prawna-biznesu" element={<ObslugaPrawnaBiznesu />} />
          <Route path="/doradztwo-strategiczne" element={<DoradztwoStrategiczne />} />
          <Route path="/dziekujemy" element={<ThankYouPage />} />
          <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
          <Route path="/subskrypcja-potwierdzona" element={<SubscriptionThankYou />} /> 
        </Routes>

        <Footer />

        <CookieConsent
          location="bottom"
          buttonText="Akceptuję wszystkie"
          declineButtonText="Odrzucam"
          cookieName="szynkowskiCookieConsent"
          style={{ 
            background: "rgba(10, 10, 10, 0.9)",
            color: "#A0AEC0",
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            padding: "1rem",
            zIndex: 9999
          }}
          buttonStyle={{ 
            background: "linear-gradient(to right, #f97316, #ea580c)",
            color: "white", 
            fontSize: "14px",
            fontWeight: "bold",
            borderRadius: "9999px",
            padding: "12px 24px"
          }}
          declineButtonStyle={{
            background: "#374151",
            color: "white",
            fontSize: "14px",
            borderRadius: "9999px",
            padding: "12px 24px"
          }}
          expires={150}
          enableDeclineButton
          onAccept={handleAcceptCookie}
          onDecline={handleDeclineCookie}
        >
          <span style={{ fontSize: "14px" }}>
            Nasza strona internetowa używa plików cookies w celu personalizacji reklam i analizy ruchu. Wyraź zgodę, aby w pełni korzystać z serwisu. Dowiedz się więcej w naszej{" "}
            <a href="/polityka-prywatnosci" style={{ color: "#F97316", textDecoration: 'underline' }}>
              Polityce Prywatności
            </a>.
          </span>
        </CookieConsent>
      </div>
    </Router>
  );
};

export default App;